import {
    booleanToDayNameMap,
    WeeklyDayPicker,
} from '../../../../inputs/WeeklyDayPicker/WeeklyDayPicker'
import React from 'react'
import { DaysPicked } from '../../../../../types/schedule'
import { DAYS_OF_WEEK } from './lib/PluginSchedule'

interface SchedulesDaysOfWeekProps {
    schema: any
    daysOfWeek: Record<keyof typeof booleanToDayNameMap, boolean>
    dataPath: string[]
    onDaysOfWeekChange: (path: string[], days: any) => void
    isRuleActive?: boolean
}

export const ScheduleDaysOfWeek = (props: SchedulesDaysOfWeekProps) => {
    const { daysOfWeek, dataPath, onDaysOfWeekChange, isRuleActive } = props
    const className = isRuleActive ? '' : 'opacity-50'
    const path = [...dataPath, DAYS_OF_WEEK]

    const handleDayOfWeekChange = (value: Partial<DaysPicked>) => {
        onDaysOfWeekChange(path, { ...daysOfWeek, ...value })
    }

     return (
         <WeeklyDayPicker
             daysPicked={daysOfWeek}
             onChange={handleDayOfWeekChange}
             className={`w-100 mb-2 rounded ${className}`}
         />
     )
}